<template>
    <div class="bannerInterno container-fluid">
      <div class="row ">
        <div class="bannerInterno__imagem col-12" :style="'background-image: url('+ require('@/assets/img/' + this.banner) +')'">
          <div class="container h-100">
            <div class="row justify-content-center align-items-center h-100 bannerInterno__imagem__dados">
              <h1 class="ui-title ui-title--white ui-title--uppercase"><b>{{titulo}}</b></h1>
              <div class="bannerInterno__imagem__dados__imagem col-12" :style="'background-image: url('+imagem+')'"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
export default {
  props: ['banner', 'imagem', 'titulo']
}
</script>
<style lang="scss">
@import '../assets/scss/_variables.scss';

.bannerInterno{
  &__imagem{
    min-height: 70vh;
    @media (max-width: 1600px) {
      min-height: 60vh;
    }
    @media (max-width: 1400px) {
      min-height: 65vh;
    }
    @media (max-width: 500px){
      min-height: 60vh;
    }
    &__dados{
      position: relative;
      h1{
        margin-bottom: 1em;
        @media (max-width: 1400px){
          margin-bottom: 0em;
        }
        @media (max-width: 400px){
          margin-top: 1em;
        }
      }
    }
  }
}
.bannerInterno__imagem__dados__imagem{
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  position: absolute;
  bottom: -18em;
  border-radius: 10px;
  box-shadow: 0px 7px 30px 10px rgba(0, 0, 0, 0.25);
  height: 31.5em;
  @media (max-width: 1600px) {
    height: 27.5em;
  }
  @media (max-width: 1400px) {
    height: 22.5em;
  }
  @media (max-width: 1024px) and (max-height: 1400px) {
    height: 18.5em;
    bottom: -10em;
  }
  @media (max-width: 992px) {
    height: 18.5em;
    bottom: -10em;
  }
  @media (max-width: 768px) and (max-height: 1200px) {
    height: 18.5em;
    bottom: -10em;
  }
  @media (max-width: 768px) and (max-height: 1100px) {
    height: 15em;
    bottom: -8em;
  }
  @media (max-width: 500px){
    height: 12em;
    bottom: -5em;
  }
  @media (max-width: 400px){
    height: 10em;
    bottom: -5em;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/BannerInterno.vue